import React, { Component } from 'react'
import { KeyboardDatePicker as DPicker } from '@material-ui/pickers';

export class DatePicker extends Component{

  handleChange = date => {
    this.props.onChange({
      target: {
        value: date ? date.format('YYYY-MM-DD') : date
      }
    })
  }

  get value(){
    return this.props.value ? new Date(this.props.value) : null
  }

  openOnFocus = () =>{
    if(this._picker && !this.value){
      this._picker.wrapper.open()
      this._picker = null
    }
  }

  render = () =>
    <DPicker
      format="DD/MM/YYYY"
      ampm={false}
      {...this.props}
      pickerRef={_picker => this._picker = _picker}
      onChange={this.handleChange}
      value={this.value}
      onFocus={this.openOnFocus}
    />

}

export default DatePicker